import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { PipeModule } from 'v2/modules/shared/pipes/pipe.module';
import { trackById } from 'v2/modules/shared/util/track-by.util';

import { IKitItem } from '../../interfaces';

interface IKitWarehouseGroup {
  id :number;
  name :string;
  items :IKitItem[];
  total :number; // Total kits that can be composed for each warehouse
}

@Component({
  selector: 'lum-rfq-kit-items-warehouse',
  standalone: true,
  imports: [CommonModule, PipeModule],
  templateUrl: './rfq-kit-items-warehouse.component.html',
  styleUrls: ['./rfq-kit-items-warehouse.component.scss'],
})
export class RfqKitItemsWarehouseComponent implements OnInit {
  @Input()
  kitItems :any[];

  warehouseGroups :IKitWarehouseGroup[] = [];
  trackById = trackById;

  ngOnInit() :void {
    this.#initWarehouseGroups();
  }

  #initWarehouseGroups() :void {
    this.kitItems.forEach((item) => {
      if (!item?.product?.location_stocks?.length) {
        return;
      }

      item.product.location_stocks.forEach((locationStock) => {
        locationStock.warehouse.warehouse_group.forEach((warehouseGroup) => {
          // Check if the warehouse group already exists
          let existingWarehouseGroup = this.warehouseGroups.find(
            (group) => group.id === warehouseGroup.id,
          );

          if (!existingWarehouseGroup) {
            // If not, create and add a new warehouse group
            existingWarehouseGroup = {
              id: warehouseGroup.id,
              name: warehouseGroup.label,
              items: [],
              total: Infinity, // Start with Infinity, we'll calculate the minimum kits later
            };
            this.warehouseGroups.push(existingWarehouseGroup);
          }

          existingWarehouseGroup.items.push({
            ...item,
            qty_onhand: locationStock.qty_onhand,
            qty_pending: locationStock.qty_pending,
            warehouse: locationStock.warehouse,
          });

          // Calculate available quantity for the product
          const availableQuantity =
            locationStock.qty_onhand - (locationStock.qty_pending || 0);

          // Calculate how many kits can be composed based on this product's availability
          const kitsFromThisProduct = Math.floor(
            availableQuantity / parseInt(item.quantity, 10),
          );

          // Update the `total` to the minimum value (bottleneck product)
          existingWarehouseGroup.total = Math.max(
            0,
            Math.min(existingWarehouseGroup.total, kitsFromThisProduct),
          );
        });
      });
    });
  }
}
